import { useAuth } from "../../../components/Auth";
import {
  renderCardSection,
  renderIndicationDisplay,
  renderAnyHitDetails,
  renderUnnaturalTextCard,
  renderGeppettoCard,
} from "./TextAnalysisDataReviewUtils";
import { getScreeningOutcomeItems } from "../../../helpers";
import { getSignalTooltipConfig } from "stm-frontend-library";

const TextAnalysisDataReview = ({ data, onActionSelect, onActionUndo }) => {
  const authData = useAuth();

  const torturedPhrases = getScreeningOutcomeItems(data, "torturedPhrases");
  const suspectPhrases = getScreeningOutcomeItems(data, "suspectPhrases");
  const genAIResponse = getScreeningOutcomeItems(data, "genAIResponse");
  const unnaturalText = getScreeningOutcomeItems(data, "unnaturalText");
  const geppettoScores = getScreeningOutcomeItems(data, "geppetto");

  const renderSignalSection = (items, signalKey, renderFunction) => {
    const config = getSignalTooltipConfig(signalKey);
    const header = config?.header || signalKey;
    const tooltip = config?.tooltip || null;
    const key = config?.key || signalKey;

    return renderCardSection(
      items,
      header,
      renderFunction,
      key,
      tooltip,
      "my-2",
      onActionSelect,
      onActionUndo,
      data,
      authData
    );
  };

  return (
    <>
      {renderSignalSection(torturedPhrases, 'torturedPhrases', renderIndicationDisplay)}
      {renderSignalSection(suspectPhrases, 'suspectPhrases', renderAnyHitDetails)}
      {renderSignalSection(genAIResponse, 'genAIResponse', renderAnyHitDetails)}
      {renderSignalSection(unnaturalText, 'unnaturalText', renderUnnaturalTextCard)}
      {renderSignalSection(geppettoScores, 'geppetto', renderGeppettoCard)}
    </>
  );
};

export default TextAnalysisDataReview;